import {
  AnimationSettingsModel,
  BeforeOpenEventArgs,
  Dialog,
  DialogComponent,
  PositionDataModel,
} from '@fluentsms/syncfusion';
import * as React from 'react';
import { specialCharacters } from './specialCharacters';

export interface SpecialCharactersDialogProps {
  insertCharacter: (value: string) => void;
  /** Set a max height for the dialog if it is positioned too close to the bottom of the page */
  maxHeight?: string;
  target?: HTMLElement | string;
}

export class SpecialCharactersDialog extends React.Component<SpecialCharactersDialogProps> {
  animationSettings: AnimationSettingsModel = { effect: 'None' };
  state: {
    selectedCharacterCode: string;
    selectedCharacterText: string;
    visible: boolean;
  };
  dialogInstance: Dialog | undefined;
  position: PositionDataModel | undefined;

  constructor(props: SpecialCharactersDialogProps) {
    super(props);

    this.state = {
      selectedCharacterCode: '',
      visible: false,
      selectedCharacterText: '',
    };

    this.position = { Y: 'center', X: 'center' };
  }

  dialogClose(): void {
    this.setState({ visible: false });
  }

  onInsert(): void {
    this.props.insertCharacter(this.state.selectedCharacterText);
  }

  onCharacterClick(e: any, char: string): void {
    e.stopPropagation();
    if (char === this.state.selectedCharacterCode) {
      // Unselect
      this.setState({ selectedCharacterCode: '', selectedCharacterText: '' });
    } else {
      // Select
      this.setState({ selectedCharacterCode: char, selectedCharacterText: e?.target?.textContent });
    }
  }

  showDialog(yPosition?: string, xPosition?: string): void {
    if (yPosition || xPosition) {
      this.position = { Y: yPosition ?? 'center', X: xPosition ?? 'center' };
    }
    this.dialogInstance?.show();
    this.setState({ visible: true });
  }

  hideDialog(): void {
    this.dialogInstance?.hide();
  }

  render(): JSX.Element {
    return (
      <>
        {this.state.visible && (
          <div className={'e-dlg-overlay'} onClick={() => this.hideDialog()}>
            <DialogComponent
              id="specialCharactersDialog"
              data-testid="special-characters-dialog"
              showCloseIcon={false}
              animationSettings={this.animationSettings}
              visible={this.state.visible}
              width={'360px'}
              height={'auto'}
              ref={(dialog) => (this.dialogInstance = dialog as Dialog)}
              header="Special Characters"
              close={this.dialogClose.bind(this)}
              className={'special_chars_dialog'}
              onClick={(e) => e.stopPropagation()}
              position={this.position}
              beforeOpen={(args: BeforeOpenEventArgs) => {
                args.maxHeight = this.props.maxHeight || '350px';
              }}
              target={this.props.target}
            >
              <div className="special_char_container">
                {specialCharacters.map((charCode) => (
                  <div
                    key={charCode.code}
                    title={charCode.name}
                    data-testid={'symbol' + charCode.code}
                    className={charCode.code === this.state.selectedCharacterCode ? 'e-active' : ''}
                    onClick={(e) => this.onCharacterClick(e, charCode.code)}
                    dangerouslySetInnerHTML={{ __html: charCode.code }}
                  ></div>
                ))}
              </div>
              <div className={'e-footer-content'}>
                <button
                  type="button"
                  className={'e-control e-btn e-lib e-primary e-flat'}
                  data-testid={'symbol-insert-button'}
                  disabled={!this.state.selectedCharacterCode}
                  onClick={() => this.onInsert()}
                >
                  Insert
                </button>
                <button
                  type="button"
                  data-testid={'symbol-cancel-button'}
                  className={'e-control e-btn e-lib e-flat'}
                  onClick={() => this.hideDialog()}
                >
                  Cancel
                </button>
              </div>
            </DialogComponent>
          </div>
        )}
      </>
    );
  }
}

export default SpecialCharactersDialog;
